<template>
  <header class="header">
    <div class="header__side">
      <BackButtonWithBorder @back="backButtonClicked" />
    </div>
    <p class="header__title">{{ title }}</p>
    <div class="header__side" aria-hidden="true"></div>
  </header>
</template>

<script>
import BackButtonWithBorder from "@/views/Components/Atoms/BackButtonWithBorder.vue";

export default {
  name: "TheHeaderGrid",
  components: { BackButtonWithBorder },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    backButtonClicked() {
      this.backToPreviousPage();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  box-sizing: border-box;
  position: fixed;
  z-index: 99;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-content: end;
  width: 100%;
  height: 80px;
  padding: 0 16px 10px;
  background-color: var(--bg-color);

  &__side {
    display: flex;
    align-items: center;
  }

  &__title {
    grid-column: 2;
    display: flex;
    align-items: center;
    justify-self: center;
    margin: 0;
    box-sizing: border-box;
    color: #000000;
    font-size: 1rem;
    font-weight: bold;
  }
}
</style>
